import { Dispatch } from "react";
import { FormattedMessage } from "react-intl";

import { RequestFormAction, RequestFormState } from "pages/shipper/RequestForm/RequestFormState";
import ServiceForm from "pages/shipper/RequestForm/components/Service/ServiceForm";
import ProviderForm from "../../../RequestForm/components/Provider/ProviderForm";
import "./ProviderDetails.scss";

interface IProviderDetailProps {
  state: RequestFormState;
  dispatch: Dispatch<RequestFormAction>;
  childRef: React.MutableRefObject<any>;
}

function ProviderDetails({ state, dispatch, childRef }: IProviderDetailProps) {
  return (
    <>
      <div className="display-sm font-semibold mb-3xl">
        <FormattedMessage id="orderTypeSelection.providerDetails" defaultMessage="Provider details" />
      </div>
      <ServiceForm state={state} dispatch={dispatch} isQuoteRequest isConsolidated />
      <ProviderForm
        state={state}
        dispatch={dispatch}
        isMiniTender={false}
        isNewShipment={false}
        isConsolidated
        childRef={childRef}
      />
    </>
  );
}

export default ProviderDetails;
